export interface Content {
    contentId: string;
    document: Document;
    disclaimer: Disclaimer;
    featureType: string;
    videos: Video;
    resources: Resource;
    division: string;
    contentType: string;
    uploadedTime: Date;
    uploadedBy: string;
    feedback: Feedback;
}
export interface Document extends AdditionalInfo {
    documentId: number;
    path: string;
    fileName: string;
    fileDisplayName: string;
}
export interface Disclaimer {
    disclaimerId: number;
    disclaimerTitle: string;
    disclaimerMessage: string;
}
export interface Video extends AdditionalInfo {
    videoGroup: string;
    videoName: string;
    videoUrl: string;
}
export interface Videos {
    videoGroup: string;
    videos: Video;
}
export interface Resource extends AdditionalInfo {
    resourceName: string;
    resourceUrl: string;
    resourceGroup: string;
    isNewResource: boolean;
}

export class DocumentRequest {
    source: string;
    contentType: string;
    contentBase64: string;
    fileName: string
}

export interface Resources {
    resourceGroup: string;
    resources: Resource;
}


export interface Feedback {
    model: string;
    year: string;
    feature: string;
    lastName: string;
    email: string;
    firstName: string;
    feedback: string;
    includeScreenshot: boolean;
    screenshotURL: string;
    bucketName: string;
    contentName: string;
    fileName: string;
    phoneNumber: string;
    feedbackType: string;
}
export interface AdditionalInfo {
    displayName?: string;
    description? : string;
    searchKeywords?: string; 
    quickLnks? : string
}
